'use es6';

import { I18N_READY } from 'ContentEditorUI/redux/actions/actionTypes';
export const receiveI18nReady = () => ({
  type: I18N_READY
});
export const watchForI18nReady = () => dispatch => {
  dispatch(receiveI18nReady());
};